import { useTypedContext } from '../../../../../../../../../../../../../../../../../../../../../hooks/useTypedContext';
import { ReactStateTuple } from '../../../../../../../../../../../../../../../../../../../../../interfaces/ui';
import { ValidationResult } from '../../../../../../../../../../../../../types';
import { ValidationContext } from '../../../../../../../../../types';
import { useCallback } from 'react';
import { cloneDeep } from 'lodash';
import { ValidConversationTemplateItemType } from '../../../../../../../../../../../../../../../../../../../../../interfaces/conversations';

export const useHandleApply = (groupName: string, onResolve: () => void) => {
  const [validation, setValidation] =
    useTypedContext<ReactStateTuple<ValidationResult>>(ValidationContext);

  return useCallback(
    (value: string) => {
      const validationCopy = cloneDeep(validation);

      validationCopy.template.content = validationCopy.template.content.map(
        (item) => {
          if (
            item.type !== ValidConversationTemplateItemType.Feedback ||
            item.group_name !== groupName
          )
            return item;

          return {
            ...item,
            group_name: value ?? '',
          };
        }
      );

      validationCopy.ready_to_complete = false;
      setValidation(validationCopy);
      onResolve();
    },
    [groupName, onResolve, setValidation, validation]
  );
};
